import React, { useEffect, useState } from 'react';

import {
  LTCodeBlock,
  LTCopyToClipboard,
  LTIconButton,
  LTInputBox,
  JsonTheme as LtJsonTheme,
  LTSwitch,
  LTTable,
} from '@lambdatestincprivate/lt-components';
import ReactJson from '@lambdatestincprivate/react-json-view';

import { TestTypes } from '../../../../constants/View';
import DarkThemeIcon from '../../../../assets/dark-theme';
import LightThemeIcon from '../../../../assets/light-theme';

import './index.css';
import styles from './index.module.css';

const { light: lightJsonTheme = {} } = LtJsonTheme || {};

const JsonTheme = {
  LIGHT: lightJsonTheme,
  DARK: 'tomorrow',
};

const InputConfig = ({ testDetails, hideJson }) => {
  const [jsonTheme, setJsonTheme] = useState(JsonTheme.LIGHT);
  const [filteredTableData, setFilteredTableData] = useState({});
  const [capabilitiesTableData, setCapabilitiesTableData] = useState({});
  const [capabilityJson, setCapabilityJson] = useState({});
  const { capability = {} } = testDetails;

  useEffect(() => {
    const { type = '' } = testDetails;
    let capabilityJsonObj = {};
    let capabilityTableData = {};
    try {
      capabilityJsonObj = JSON.parse(capability);
      capabilityTableData = capabilityJsonObj;
      // setFilteredTableData(capabilityJson);
      // No need to expand capabilities for Cypress as the structure
      // for CYP is already flat.
      if (type !== TestTypes.CYPRESS) {
        // Flatten the desired capabilities and render them in list view.
        const desiredCapabilities = capabilityJsonObj['desiredCapabilities'];
        capabilityTableData = {
          ...capabilityTableData,
          ...desiredCapabilities,
        };
        delete capabilityTableData['desiredCapabilities'];
      }
    } catch {
      // Do nothing
    }
    setCapabilityJson(capabilityJsonObj);
    setFilteredTableData(capabilityTableData);
    // Original data for filtering.
    setCapabilitiesTableData(capabilityTableData);
  }, []);

  const toggleTheme = () => {
    setJsonTheme(
      jsonTheme === JsonTheme.LIGHT ? JsonTheme.DARK : JsonTheme.LIGHT
    );
  };

  const handleSearch = (valueToSearch) => {
    const valueToSearchLowerCase = valueToSearch?.toLowerCase();
    if (!valueToSearchLowerCase) {
      setFilteredTableData(capabilitiesTableData);
    }
    const dataEntries = Object.entries(capabilitiesTableData).filter(
      ([key, value]) => {
        const keyToCheck = key?.toLowerCase();
        if (typeof value === 'string') {
          const valueToCheck = value?.toLowerCase();
          return (
            valueToCheck.includes(valueToSearchLowerCase) ||
            keyToCheck.includes(valueToSearchLowerCase)
          );
        }
        return keyToCheck.includes(valueToSearchLowerCase);
      }
    );
    const tableData = Object.fromEntries(dataEntries);
    setFilteredTableData(tableData);
  };

  const renderHeaderActions = () => {
    return (
      <div className={styles.actionWrapper}>
        <div className={styles.actionBar}>
          <LTCopyToClipboard
            textToCopy={JSON.stringify(JSON.parse(capability), undefined, 2)}
          />
          <LTIconButton
            ariaLabel="Toggle Theme"
            data-testid="input-config-theme-toggle"
            icon={jsonTheme === JsonTheme.DARK ? LightThemeIcon : DarkThemeIcon}
            onClick={toggleTheme}
            size={LTIconButton.Size.SMALL}
            variant={LTIconButton.IconButtonVariants.INVISIBLE}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={`${styles.inputConfigCodeBlockWrapper}`} data-testid="input-config-tab-container">
      {hideJson ? (
        <div className={`${styles.tableWrapper} lt-input-config-table`}>
          <LTInputBox
            autoCompleteType="off"
            data-testid="input-config-search"
            onChange={handleSearch}
            placeholder="Search"
            size={LTInputBox.Size.MEDIUM}
            trailingAction={() => handleSearch('')}
            type="text"
          />
          <div
            style={{
              overflow: 'auto',
              height: '100%',
            }}
          >
            <div style={{ height: '1px' }}>
              <LTTable allowValueCopy={true} data={filteredTableData} />
            </div>
          </div>
        </div>
      ) : (
        <div className="lt-input-config">
          <LTCodeBlock
            dataWrapperStyle={{
              background: jsonTheme === JsonTheme.DARK ? '#1d1f21' : '#fff',
              height: '100%',
              display: 'flex',
            }}
            headerActions={renderHeaderActions()}
          >
            <div
              className={styles.inputConfigJsonWrapper}
              aria-label="Input Config JSON"
              role="region"
              tabIndex={0}
            >
              <div style={{ height: '1px' }}>
                <ReactJson
                  displayDataTypes={false}
                  displayObjectSize={false}
                  enableClipboard={false}
                  name={false}
                  src={capabilityJson}
                  theme={jsonTheme}
                />
              </div>
            </div>
          </LTCodeBlock>
        </div>
      )}
    </div>
  );
};

export default InputConfig;
